import React from 'react';
import { Link, useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import Button from '@components/Button';
import { signUpUrl, loginUrl } from '@helpers/urls';
import triangleIcon from '@icons/triangleIcon';
import menuDropdownIcon from '@icons/menuDropdownIcon';

import * as styles from './style.module.scss';

const {
    navigationButtons__ctaGreen,
    button,
  } = styles;
  
const NavCta = ({
  greenButton = false,
  classes = "",
}) => {
  const { originalPath, language, path } = useI18next();
  const { t } = useTranslation();

  const isMilestoneCustomerPage = path.includes('/crm-intelligence-offer');

  if (isMilestoneCustomerPage) {
    return null;
  }
  
  const isWebVisitorsPage =
    path.includes('/solutions/web-visitor-tracking/') ||
    path.includes('/web-visitors/');
  const isIpEnrichPage = path.includes('/ip-enrich-api');

  return isWebVisitorsPage ? (
    <Button
      classes={button}
      href={signUpUrl(language, {
        ref: 'dealfront',
        cta: 'top-nav',
      })}
      external
      size="small"
    >
      {t('nav_cta_free_trial')}
    </Button>
  ) : (
    <Button
      classes={`${button} ${greenButton ? navigationButtons__ctaGreen : ''}`}
      href={`/request-demo?ref=dealfront&cta=top-nav${
        isIpEnrichPage ? '&formName=request-ip-enrich' : ''
      }`}
      size="small"
    >
      {t('nav_cta_request_demo')}
    </Button>
  );
};
  

export default NavCta;